import React from "react";
import { Link } from "react-router-dom";
import { Phone, MapPin, Mail, Instagram, Youtube, Linkedin, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[#050812] border-t border-[#1F2937] pt-20 pb-10 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-4 gap-12 mb-16">
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-12 h-12 border border-[#C9A961] flex items-center justify-center text-[#C9A961] font-heading text-lg tracking-[0.15em]">YK</div>
              <div>
                <div className="text-white font-heading tracking-[0.2em] text-base">İNŞAAT</div>
                <div className="text-[#C9A961] text-[10px] tracking-[0.3em] uppercase">Müteahhitlik</div>
              </div>
            </div>
            <p className="text-white/60 text-sm leading-relaxed">
              Değer üretiyoruz, hayalleri inşa ediyoruz. 25 yılı aşkın tecrübemizle modern yaşam alanları sunuyoruz.
            </p>
          </div>

          <div>
            <div className="section-label mb-6">Sayfalar</div>
            <ul className="space-y-3">
              {[
                { to: "/", label: "Ana Sayfa" },
                { to: "/kurumsal", label: "Kurumsal" },
                { to: "/hizmetler", label: "Hizmetlerimiz" },
                { to: "/projeler", label: "Projeler" },
                { to: "/iletisim", label: "İletişim" },
              ].map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-white/70 hover:text-[#C9A961] text-sm inline-flex items-center gap-2 group">
                    <span>{l.label}</span>
                    <ArrowUpRight className="w-3.5 h-3.5 opacity-0 -translate-x-1 group-hover:opacity-100 group-hover:translate-x-0 transition-all" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="section-label mb-6">İletişim</div>
            <ul className="space-y-4 text-sm">
              <li className="flex items-start gap-3 text-white/70">
                <Phone className="w-4 h-4 text-[#C9A961] mt-1 shrink-0" strokeWidth={1.5} />
                <a href="tel:05449751294" className="hover:text-[#C9A961]">0544 975 12 94</a>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="w-4 h-4 text-[#C9A961] mt-1 shrink-0" strokeWidth={1.5} />
                <span>Şarhöyük mahallesi bülbüller Sokak no 50/B</span>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <Mail className="w-4 h-4 text-[#C9A961] mt-1 shrink-0" strokeWidth={1.5} />
                <a href="mailto:info@ykinsaat.com" className="hover:text-[#C9A961]">info@ykinsaat.com</a>
              </li>
            </ul>
          </div>

          <div>
            <div className="section-label mb-6">Bizi Takip Edin</div>
            <div className="flex items-center gap-3">
              {[Instagram, Youtube, Linkedin].map((Icon, i) => (
                <a
                  key={i}
                  href="#"
                  className="w-10 h-10 border border-[#1F2937] hover:border-[#C9A961] flex items-center justify-center text-white/70 hover:text-[#C9A961] transition-colors"
                >
                  <Icon className="w-4 h-4" strokeWidth={1.5} />
                </a>
              ))}
            </div>
            <div className="mt-8 text-xs text-white/40 tracking-widest uppercase">Yatırım İçin</div>
            <Link to="/iletisim" className="mt-2 inline-block text-[#C9A961] hover:text-[#DBC082] text-sm border-b border-[#C9A961]/40 pb-0.5 tracking-wider">
              Proje Geliştirme →
            </Link>
          </div>
        </div>

        <div className="pt-8 border-t border-[#1F2937] flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="text-white/40 text-xs tracking-wider">
            © {new Date().getFullYear()} YK İnşaat Müteahhitlik. Tüm hakları saklıdır.
          </div>
          <div className="flex items-center gap-6">
            <a
              href="https://codexsan.online"
              target="_blank"
              rel="noreferrer"
              lang="en"
              data-testid="codexsan-credit"
              className="yk-rgb-text text-[11px] hover:tracking-[0.45em] transition-all duration-500"
            >
              DESIGN BY CODEX-SAN WEB
            </a>
            <Link to="/admin/login" className="text-white/30 hover:text-[#C9A961] text-[10px] uppercase tracking-[0.3em]" data-testid="footer-admin-link">
              Yönetim Paneli
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
